<!-- <mat-toolbar>
  <mat-toolbar-row class="justify-content-between">
    <button mat-icon-button (click)="toggleSidebar()">
      <mat-icon>menu</mat-icon>
    </button>
    <div class="row mr-2 ml-auto">
      <ul class="row m-0 align-items-center">
        <li>
          <button
            mat-button
            [matMenuTriggerFor]="menu"
            class="user mt-2 d-flex align-items-center"
          >
            <img src="./assets/user.jpg" alt="" class="user-image mr-1 p-2" />

            User Name
            <mat-icon class="user-image-icon ml-1"
              >keyboard_arrow_down</mat-icon
            >
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="logout()">
              <mat-icon>exit_to_app</mat-icon>
              Logout
            </button>
          </mat-menu>
        </li>
      </ul>
    </div>
  </mat-toolbar-row>
</mat-toolbar> -->

<nav class="navbar navbar-expand-lg"
  style="background-size: cover !important;border-bottom: solid 1px black; background: url(./assets/images/header.png) no-repeat 240px;">
  <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 logo-div">
    <button *ngIf="!isHideToggleButton" mat-icon-button (click)="toggleSideBar()">
      <mat-icon>menu</mat-icon>
    </button>
    <span [ngStyle]="isHideToggleButton ? {'margin-left': '10px'} : ''"> <img src="./assets/images/sf_logo.png"
        alt="Company Logo" /> </span>
  </div>
  <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8 text-right ">
    <ul style="margin: 0px !important;">
      <li>
        <span class="user-name"> Hello, {{loginUserName}}</span>
        <button *ngIf="!isDelegate && !isPWA" mat-button matTooltip="User Profile" (click)="onClickUserProfile()">
          <mat-icon>person_outline</mat-icon>
        </button>
        <button mat-button matTooltip="Logout" [matMenuTriggerFor]="menu">
          <mat-icon>input</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="logout()">
            <mat-icon>exit_to_app</mat-icon>
            Sign out
          </button>
        </mat-menu>
      </li>
    </ul>
  </div>
</nav>